import { Check, X } from 'lucide-react';
import { getPasswordChecks } from '../../lib/password';

interface PasswordChecklistProps {
  password: string;
}

export function PasswordChecklist({ password }: PasswordChecklistProps) {
  const checks = getPasswordChecks(password);

  // Don't render anything until the user starts typing
  if (!password) return null;

  return (
    <ul className="flex flex-col gap-1 mt-1">
      {checks.map(({ label, met }) => (
        <li key={label} className="flex items-center gap-1.5">
          {met ? (
            <Check size={14} className="text-emerald-600 shrink-0" />
          ) : (
            <X size={14} className="text-slate shrink-0" />
          )}
          <span className={`text-[13px] ${met ? 'text-emerald-600' : 'text-slate'}`}>
            {label}
          </span>
        </li>
      ))}
    </ul>
  );
}
